import { Box, Icon } from '@mui/material';
import * as React from 'react';

import { useSxStyles } from './useStyles';

type PropsType = {
  name: string;
  info?: string;
  value: string;
  type: string;
};

export const ReadCustomDataFields = (props: PropsType) => {
  const { name, info, value, type } = props;
  const { fieldLabel, fieldContent, infoIcon, checkbox } = useSxStyles();
  const ReadComponent = () => {
    if (type !== 'BOOLEAN') {
      return (
        <Box component="span" sx={fieldContent}>
          {value}
        </Box>
      );
    }
    return (
      <Icon
        sx={checkbox}
        className={value === 'true' ? 'fa fa-check-square-o' : 'fa fa-square-o'}
      />
    );
  };
  return (
    <div>
      <Box component="span" sx={fieldLabel}>
        {name}
      </Box>{' '}
      {!!info && (
        <Icon sx={infoIcon} className={'fa fa-info-circle'} title={`${info}`} />
      )}
      :
      <ReadComponent />
    </div>
  );
};
